import React, { useEffect, createElement } from 'react';
import { Hero } from '../components/Hero';
import { Portfolio } from '../components/Portfolio';
export const HomePage = () => {
  useEffect(() => {
    document.title = 'Home | Race Capital';
    // Inject SEO Meta Tags for the homepage preview image
    const setMetaTag = (name: string, content: string, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let element = document.querySelector(`meta[${attr}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attr, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };
    const imageUrl = 'https://cdn.magicpatterns.com/uploads/eUsdebFiSgr2rR1pSifCTE/Screenshot_2026-06-23_at_14.42.01.png';
    setMetaTag('og:image', imageUrl, true);
    setMetaTag('twitter:image', imageUrl);
    setMetaTag('twitter:card', 'summary_large_image');
  }, []);
  return <>
      <Hero data-id="element-261" data-mp="2apen0gp0i2bc" />
      <Portfolio data-id="element-262" data-mp="2apoe67lsmfim" />
    </>;
};